import type { UserSimple } from '../user.types';

export class UserSimpleModel {
  private readonly _dto: UserSimple;

  constructor(dto?: UserSimple) {
    this._dto = dto ?? ({} as UserSimple);
  }

  get originDTO(): UserSimple {
    return this._dto;
  }

  get email(): string {
    return this._dto.email || '';
  }

  get id(): string {
    return this._dto.id || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get phone(): string {
    return this._dto.phone || '';
  }

  get username(): string {
    return this._dto.username || '';
  }

  get isActive(): boolean {
    return this._dto.status === 'ACTIVE';
  }
}
